// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AGObM","amount":"styles_amount__Mxh6r","total":"styles_total__sRXXf","button":"styles_button__OFTrp"};